module.exports = {
	// apiUrl: 'http://beta.merck.ph/api'
	// apiUrl: '//localhost:8070/api',
	// apiUrl: 'http://merck-laravel-api.ap-southeast-1.elasticbeanstalk.com/api'
	// apiUrl: 'http://ph-web02.seap-cloud.com/merck-api/public/api',
	apiUrl: '//www.elitevirtuallearning.com/merck-api/public/api',
	filesUrl: 'http://elite-ph.s3.amazonaws.com/',

}


//////////////////
// WEBPACK FOOTER
// ./configApi.js
// module id = 3
// module chunks = 1